/* eslint-disable no-new */
import debounce from './debounce';

export default () => {
  const sidebarCatalog = document.querySelector('.sidebar-catalog');

  if (sidebarCatalog === null || !window.matchMedia('(min-width: 767px)').matches) {
    return;
  }
  const $sidebarWrapper = $('.page-wrapper__sidebar');
  const $sidebarCatalog = $(sidebarCatalog);
  const sidebarCatalogAdditionalOffsetTop = 30;
  const $mesuaredHeight = $('.sidebar-catalog-mesure-height');
  const $window = $(window);

  const $footerPage = $('.footer-page');

  let isSidebarScroll = false;
  let isSidebarSticky = true;

  const getSidebarInitialHeight = () => {
    const sidebarHeight = $sidebarCatalog.outerHeight();
    const windowHeight = $window.outerHeight();
    const mesuaredHeight = $mesuaredHeight.outerHeight();
    // if (sidebarHeight > windowHeight) {
    //   isSidebarScroll = true;
    //   $sidebarCatalog.addClass('sidebar-catalog--scroll');
    //   return windowHeight;
    // }
    return mesuaredHeight;
  };

  const getSidebarMaxHeight = () => {
    const maxHeight = $window.outerHeight() - $footerPage.outerHeight();
    const mesuredMaxHeight = $mesuaredHeight.outerHeight();

    if (maxHeight > mesuredMaxHeight) {
      isSidebarSticky = false;
    }
    return maxHeight;
  };

  const sidebarParams = {
    initialHeight: getSidebarMaxHeight(),
    maxHeight: getSidebarMaxHeight(),
    initialWidth: $sidebarWrapper.outerWidth(),
    footerVisible: $window.scrollTop() + $window.outerHeight() - $footerPage.offset().top,
    offsetTop: $sidebarWrapper.offset().top,
  };


  const setInitialSidebarWidth = (width) => {
    $sidebarCatalog.width(width);
  };

  const sidebarToggleFixed = () => {
    if ($window.scrollTop() > sidebarParams.offsetTop - sidebarCatalogAdditionalOffsetTop) {
      $sidebarCatalog.addClass('is-active');
    } else {
      $sidebarCatalog.removeClass('is-active');
    }
  };

  // eslint-disable-next-line no-undef
  new SimpleBar(sidebarCatalog);

  const changeSidebarHeight = () => {
    $sidebarCatalog.css({
      height: `${sidebarParams.maxHeight}px`,
    });
    // const footerVisible = $window.scrollTop() + $window.outerHeight() - $footerPage.offset().top;
    // if (footerVisible > 0) {
    //   $sidebarCatalog.css({
    //     height: `${sidebarParams.maxHeight}px`,
    //   });
    //   if (!isSidebarScroll) {
    //     $sidebarCatalog.addClass('sidebar-catalog--scroll');
    //   }
    // } else {
    //   $sidebarCatalog.css({
    //     height: `${sidebarParams.initialHeight}px`,
    //   });
    //   if (!isSidebarScroll) {
    //     $sidebarCatalog.removeClass('sidebar-catalog--scroll');
    //   }
    // }
  };

  if (isSidebarSticky) {
    sidebarToggleFixed();
    changeSidebarHeight();
  }


  setInitialSidebarWidth(sidebarParams.initialWidth);
  $window.on('scroll', debounce(() => {
    if (isSidebarSticky) {
      sidebarToggleFixed();
      // changeSidebarHeight();
    }
  }, 5));

  $window.on('resize', () => {
    sidebarParams.maxHeight = getSidebarMaxHeight();
    sidebarParams.initialHeight = getSidebarMaxHeight();
    sidebarParams.initialWidth = $sidebarWrapper.outerWidth();
    sidebarParams.footerVisible = $window.scrollTop()
      + $window.outerHeight() - $footerPage.offset().top;
    sidebarParams.offsetTop = $sidebarWrapper.offset().top;

    setInitialSidebarWidth(sidebarParams.initialWidth);
  });
};
